const mutations = {
    PLAN_LOADING: state => {
        state.planStatus = "loading";
    },
    UPDATE_PRICE: (state, price) => {
        state.planCart.p_price = parseFloat(price);
    },
    UPDATE_PLAN_CART: (state, cart) => {
        state.planCart.p_name = cart.name;
        state.planCart.p_price = parseFloat(cart.price);
    },
    RESET_TOTALS: state => {
        state.planCart.p_price = parseFloat(0.0);
    },
    UPDATE_PLANS: (state, plans) => {
        state.plans = plans;
    },
    PLAN_SUCCESS: (state, data) => {
        state.planStatus = "success";
        Vue.set(state, "plans", data);
        Vue.set(state, "plansCount", data.length);
    },
    PLAN_CART_SUCCESS: (state, plan) => {
        state.planStatus = "success";
        Vue.set(state, "planCart", plan);
    },
    PLAN_ERROR: (state, err) => {
        let errors = err.error ? err.error : {};

        state.planStatus = "error";
        state.planErrors.record(errors);
    },
    CLEAR_PLAN_ERROR: state => {
        state.planStatus = "";
        state.planErrors.clear();
    },
    CLEAR_PAYMENT_ERRORS: state => {
        state.paymentStatus = "";
        state.paymentErrors.clear();
    },
    PAYMENT_LOADING: state => {
        state.paymentStatus = "loading";
    },
    PAYMENT_SUCCESS: state => {
        state.paymentStatus = "success";
    },
    PAYMENT_ERROR: (state, err) => {
        let errors = err.error ? err.error : {};

        state.paymentStatus = "error";
        state.paymentErrors.record(errors);
    },
    RESET_STATE: state => {
        Object.assign(state, state.initialState());
    },
};

export default mutations;
